import React from 'react';

const HomeScene = () => {
  return <span>Welcome</span>;
};

export default HomeScene;
